module.exports = __webpack_public_path__ + "static/media/desktop-alt.83d26d75.svg";